/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TechReqStatusChip from '../../../components/common/datagrid/TechReqStatusChip';
import TechList from '../../../components/projectmng/support/TechList';
import { listProjectTechs } from '../../../modules/projectModule/projectTechs';



const TechListContainer = ({ selectedTech }) => {
  const dispatch = useDispatch();

  const { project, techs, error, loading } = useSelector(
    ({ projectModule, loading }) => ({
      project: projectModule.project.project,
      techs: projectModule.projectTechs.techs,
      error: projectModule.projectTechs.error,
      loading: loading['project/LIST_PROJECT_TECHS'],
    }),
  );

  useEffect(() => {
    if (project) {
      dispatch(listProjectTechs(project.prjUuid));

    }
    //언마운트될때 리덕스에서 파트너 데이터 초기화
    // return () => {
    //   dispatch(unloadTechs());
    // };
  }, [dispatch, project]);

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'reqUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'prjUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'reqStatus',
        headerName: '작업상태',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: TechReqStatusChip,
      },
      {
        field: 'reqNo',
        headerName: '작업요청번호',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },

      {
        field: 'workTyp',
        headerName: '작업종류',
        minWidth: 120,
        flex: 0.6,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'workStDt',
        headerName: '작업 요청 시작일',
        minWidth: 120,
        flex: 0.6,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'workEdDt',
        headerName: '작업 요청 종료일',
        minWidth: 120,
        flex: 0.6,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'custEmpNm',
        headerName: '담당자',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'workEmpNm',
        headerName: '작업자',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'crtNm',
        headerName: '작성자',
        minWidth: 80,
        flex: 0.3,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'crtDt',
        headerName: '작성일',
        minWidth: 120,
        flex: 0.6,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
    ],
    [],
  );

  const handleRowClick = (param, event) => {
    // console.log("Row:");
    // console.log(param);
    // console.log(event);
    selectedTech(param.row);
  };

  return (
    <>
      <TechList
        columns={columns}
        rows={techs}
        loading={loading}
        handleRowClick={handleRowClick}
        columnVisibilityModel={{
          id: false,
          reqUuid: false,
          prjUuid: false,
        }}

      />
    </>
  );
};

export default TechListContainer;
